import "../../Styling/Workflow.css";
import code from "../../Assets/Images/code.mp4"
import feedback from "../../Assets/Images/feedback.mp4"

const Workflow = () => {
  return (
    <div className="workflow-wrapper">
      <h2 className="workflow-title">From inspiration to creation.</h2>
      <div className="workflow-grid">
        {/* Workflow 1 */}
        <figure className="workflow-figure">
          <div className="workflow-figure-video-wrapper">
            <video
              className="workflow-figure-video"
              controlsList="nofullscreen"
              controls={false}
              autoPlay
              muted
              loop
              disablePictureInPicture
              disableRemotePlayback
              playsInline
            >
              <source
                type="video/mp4"
                src="https://bytescale.mobbin.com/FW25bBB/video/assets/videos/lp_features_copy_to_figma.mp4?mute=true&amp;f=mp4-h264&amp;a=%2Fvideo.mp4&amp;w=800&amp;sh=90&amp;q=7&amp;fps=60"
              />
            </video>
          </div>
          <figcaption>
            <p className="workflow-figure-title">Design</p>
            <p className="workflow-figure-body">
              Turning ideas into sleek, user-centered designs.
            </p>
          </figcaption>
        </figure>

        {/* Workflow 2 */}
        <figure className="workflow-figure">
          <div className="workflow-figure-video-wrapper">
            <video
              className="workflow-figure-video"
              controlsList="nofullscreen"
              controls={false}
              autoPlay
              muted
              loop
              disablePictureInPicture
              disableRemotePlayback
              playsInline
            >
              <source
                type="video/mp4"
                src={code}
              />
            </video>
          </div>
          <figcaption>
            <p className="workflow-figure-title">Code</p>
            <p className="workflow-figure-body">
              Writing the future of your app with clean, scalable code.
            </p>
          </figcaption>
        </figure>

        {/* Workflow 3 */}
        <figure className="workflow-figure">
          <div className="workflow-figure-video-wrapper">
            <video
              className="workflow-figure-video"
              controlsList="nofullscreen"
              controls={false}
              autoPlay
              muted
              loop
              disablePictureInPicture
              disableRemotePlayback
              playsInline
            >
              <source
                type="video/mp4"
                src={feedback}
              />
            </video>
          </div>
          <figcaption>
            <p className="workflow-figure-title">Feedback</p>
            <p className="workflow-figure-body">
              Your feedback drives our innovation — we build it, you shape it.
            </p>
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Workflow;
